import styled from 'styled-components'
import moment from 'moment'

import MailOutlineIcon from '@mui/icons-material/MailOutline'
import { ROUTES } from '../constants/routes'

const Footers = styled.footer`
  min-height: 124px;
  padding: 24px clamp(20px, 4vw, 48px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  color: ${({ theme }) => theme.colors.textMuted};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  font-size: 0.75rem;

  p { margin: 0; }

  a:hover {
    color: ${({ theme }) => theme.colors.text};
    text-decoration: underline;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    min-height: auto;
    align-items: flex-start;
    flex-direction: column;
  }
`

const Contact = styled.p`
  display: inline-flex;
  align-items: center;
  gap: 6px;

  svg { font-size: 1rem; }
`

const Legal = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobile}) {
    justify-content: flex-start;
  }
`

export default function Footer() {
  return (
    <Footers>
      <Contact>
        <MailOutlineIcon aria-hidden="true"/>
        <a href="mailto:support@akive.net">support@akive.net</a>
      </Contact>
      <Legal>
        <span>© {moment().format('YYYY')} akive</span>
        <a href={ROUTES.TERMS_OF_SERVICE}>서비스 이용약관</a>
        <a href={ROUTES.OPEN_SOURCE_LICENSES}>오픈소스 라이선스</a>
        <a href={ROUTES.PRIVACY_POLICY}>개인정보 처리방침</a>
      </Legal>
    </Footers>
  )
}
